import { HttpClient } from './http-client';
import { Observable } from 'rxjs';
import Ability from '../interfaces/ability';

export class AbilityService extends HttpClient {
  index(): Observable<Ability[]> {
    return this.get<Ability[]>('/api/internal/abilities');
  }
  dependsOn(ids: string | string[]): Observable<Ability[]> {
    if (typeof ids === 'string') {
      ids = [ids];
    }
    return this.post<Ability[]>(`/api/services/abilities/dependsOn`, {
      ids: ids,
    });
  }
  isDependencyOf(ids: string | string[]): Observable<Ability[]> {
    if (typeof ids === 'string') {
      ids = [ids];
    }
    return this.post<Ability[]>(`/api/services/abilities/isDependencyOf`, {
      ids: ids,
    });
  }
}
